import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const blockAndUnBlockAdminAction = createAsyncThunk(
    'block-unblock',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/block-unblock`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const blockAndUnBlockAdminSlice = createSlice({
    name: 'block-unblock',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(blockAndUnBlockAdminAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(blockAndUnBlockAdminAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(blockAndUnBlockAdminAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const blockAndUnBlockAdminReducer = blockAndUnBlockAdminSlice.reducer